import DashboardLayout from "examples/LayoutContainers/DashboardLayout";
import DashboardNavbar from "examples/Navbars/DashboardNavbar";
import Footer from "examples/Footer";
import MDBox from "components/MDBox";
import MDTypography from "components/MDTypography";
import Card from "@mui/material/Card";
import Grid from "@mui/material/Grid";
// import { useNavigate, useParams } from 'react-router-dom';
import { useEffect, useState } from "react";
import MDButton from 'components/MDButton';
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
// import TableContainer from '@mui/material/TableContainer';
// import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
import { Oval } from 'react-loader-spinner';
import Select from "react-select";
import "react-datepicker/dist/react-datepicker.css";
import * as moment from 'moment';
// import { Radio } from '@mui/material';
import * as service from '../../services/service';

function CaseStatusReport() {
    const [courtData, setCourtData] = useState([]);
    const [courtId, setCourtId] = useState('');
    const [caseTypeData, setCaseTypeData] = useState([]);
    const [caseTypeId, setCaseTypeId] = useState('');
    const [caseData, setCaseData] = useState([]);
    const [caseDataForDropdown, setCaseDataForDropdown] = useState([]);
    const [caseId, setCaseId] = useState('');
    const [caseDetails, setCaseDetails] = useState([]);
    const [data, setData] = useState([]);
    // const [caseStageData, setCaseStageData] = useState([]);
    // const [detailId, setDetailId] = useState('');
    // const [caseStatusData, setCaseStatusData] = useState([]);
    const [errors, setErrors] = useState({});
    const [loading, setLoading] = useState(false);
    const selectStyles = { menu: styles => ({ ...styles, zIndex: 999 }) };
    // const params = useParams();
    // const navigate = useNavigate();
    // const userTyp = JSON.parse(sessionStorage.getItem('userData')).userType;

    const getCourts = () => {
        fetch(
            service.COURTS_URL,
            {
                method: 'POST',
                headers: {
                    'Accept': 'application/json',
                    'Content-Type': 'application/json'
                },
            })
            .then(res => res.json())
            .then(result => {
                const data2 = result.map((item) => ({ value: item.courtId, label: item.court }));
                setCourtData(data2);
            });
    };

    const getCaseTypes = (id) => {
        fetch(
            service.GET_CASE_TYPE_BY_COURT_ID,
            {
                method: 'POST',
                headers: {
                    'Accept': 'application/json',
                    'Content-Type': 'application/json'
                },
                body: JSON.stringify({
                    CourtId: id
                })
            })
            .then(res => res.json())
            .then(result => {
                const data2 = result.map((item) => ({ value: item.caseTypeId, label: item.caseType }));
                setCaseTypeData(data2);
            });
    };
    const getCaseDetails = (id) => {
        const errs = {};
        const url = service.GET_CASE_DETAILS_BY_CASE_TYPE_ID;
        fetch(
            url,
            {
                method: 'POST',
                headers: {
                    'Accept': 'application/json',
                    'Content-Type': 'application/json'
                },
                body: JSON.stringify({
                    CaseTypeId: id,
                    AddedBy: JSON.parse(sessionStorage.getItem('userData')).userId,
                })
            })
            .then(res => res.json())
            .then(result => {
                setCaseData(result);
                const data2 = result.map((item) => ({ value: item.caseId, label: item.caseNo }));
                setCaseDataForDropdown(data2);
            })
            .catch(err => {
                if (err) {
                    errs[".invalid"] = err;
                    setErrors(err);
                };
            });
    };
    // const getCaseStages = (id) => {
    //     const errs = {};
    //     fetch(
    //         service.GET_CASE_STAGE_DETAILS_BY_CASE_ID,
    //         {
    //             method: 'POST',
    //             headers: {
    //                 'Accept': 'application/json',
    //                 'Content-Type': 'application/json'
    //             },
    //             body: JSON.stringify({
    //                 CaseId: id,
    //             })
    //         })
    //         .then(res => res.json())
    //         .then(result => {
    //             setCaseStageData(result);
    //         })
    //         .catch(err => {
    //             if (err) {
    //                 errs[".invalid"] = err;
    //                 setErrors(err);
    //             };
    //         });
    // };

    const getDetails = () => {
        const errs = {};
        fetch(
            service.GET_CASE_STATUS_DETAILS_BY_CASE_ID,
            {
                method: 'POST',
                headers: {
                    'Accept': 'application/json',
                    'Content-Type': 'application/json'
                },
                body: JSON.stringify({
                    CaseId: caseId.value,
                })
            })
            .then(res => res.json())
            .then(result => {
                setData(result);
            })
            .catch(err => {
                if (err) {
                    errs[".invalid"] = err;
                    setErrors(err);
                };
            });
    };

    useEffect(() => {
        setLoading(true);
        getCourts();
        setLoading(false);
    }, []);

    const validate = () => {
        let isValid = true;
        const errs = {};
        if (!caseId) {
            isValid = false;
            errs[".caseId"] = "Please select Case";
        }
        setErrors(errs);
        return isValid;
    }

    const CourtChangeHandler = (ev) => {
        setCourtId(ev);
        setCaseTypeId(null);
        getCaseTypes(ev.value);
    }
    const CaseTypeChangeHandler = (ev) => {
        setCaseTypeId(ev);
        setCaseId(null);
        getCaseDetails(ev.value);
    }

    const CaseChangeHandler = (ev) => {
        setCaseId(ev);    }

    const submitHandler = e => {
        e.preventDefault();
        setLoading(true);
        if (validate()) {
            const details = caseData.find(x => x.caseId === caseId.value);
            setCaseDetails(details);
            getDetails();
        }
        setLoading(false);
    }
    return (
        <DashboardLayout>
            <DashboardNavbar />
            <MDBox pt={6} pb={3}>
                <Grid container spacing={6}>
                    <Grid item xs={12}>
                        <Card>
                            <MDBox
                                mx={2}
                                mt={-3}
                                py={3}
                                px={2}
                                variant="gradient"
                                bgColor="info"
                                borderRadius="lg"
                                coloredShadow="info"
                            >
                                <MDTypography variant="h6" color="white">
                                    Case Status Report
                                </MDTypography>
                            </MDBox>
                            <br />
                            <Card style={{ alignItems: 'center' }}>
                                <Table>
                                    <TableBody>
                                        <TableRow>
                                            <TableCell>
                                                <Select
                                                    name="Court"
                                                    options={courtData} placeholder="Select Court"
                                                    value={courtId}
                                                    onChange={CourtChangeHandler}
                                                    isSearchable
                                                    styles={selectStyles}
                                                />
                                                <div style={{ fontSize: '12px', color: 'red' }}>{errors[".courtId"]}</div>
                                            </TableCell>
                                            <TableCell>
                                                <Select
                                                    name="Case Type"
                                                    options={caseTypeData} placeholder="Select Case Type"
                                                    value={caseTypeId}
                                                    onChange={CaseTypeChangeHandler}
                                                    isSearchable
                                                    styles={selectStyles}
                                                />
                                                <div style={{ fontSize: '12px', color: 'red' }}>{errors[".caseTypeId"]}</div>
                                            </TableCell>
                                        </TableRow>
                                        <TableRow>
                                            <TableCell>
                                                <Select
                                                    name="Case"
                                                    options={caseDataForDropdown} placeholder="Select Case"
                                                    value={caseId}
                                                    onChange={CaseChangeHandler}
                                                    isSearchable
                                                    styles={selectStyles}
                                                />
                                                <div style={{ fontSize: '12px', color: 'red' }}>{errors[".caseId"]}</div>
                                            </TableCell>
                                        </TableRow>
                                    </TableBody>
                                </Table>
                                <MDBox mt={4} mb={1} textAlign="center">
                                    {loading ? <Oval
                                        heigth="20"
                                        width="20"
                                        color='grey'
                                        ariaLabel='loading'
                                    /> :
                                        <div>
                                            <MDButton color="info" onClick={submitHandler}>
                                                Show
                                            </MDButton>
                                        </div>
                                    }
                                    {errors ? <div style={{ fontSize: '12px', color: 'red' }}>{errors[".invalid"]}</div> : null}
                                </MDBox>
                                <Table>
                                    <TableRow>
                                        <TableCell style={{ fontSize: '14px' }}>
                                            Case No : {caseDetails ? caseDetails.caseNo : ''}
                                        </TableCell>
                                        <TableCell style={{ fontSize: '14px' }}>
                                            Notice No : {caseDetails ? caseDetails.noticeNo : ""}
                                        </TableCell>
                                    </TableRow>
                                    <TableRow>
                                        <TableCell style={{ fontSize: '14px' }}>
                                            Notice Date : {caseDetails ? moment(caseDetails.noticeDate).format('DD/MM/YYYY') : ""}
                                        </TableCell>
                                        <TableCell style={{ fontSize: '14px' }}>
                                            Project : {caseDetails ? caseDetails.project : ""}
                                        </TableCell>
                                    </TableRow>
                                    <TableRow>
                                        <TableCell style={{ fontSize: '14px' }}>
                                            Case Subject : {caseDetails ? caseDetails.caseSubject : ''}
                                        </TableCell>
                                        <TableCell style={{ fontSize: '14px' }}>
                                            Complainant : {caseDetails ? caseDetails.complainant : ""}
                                        </TableCell>
                                    </TableRow>
                                    <TableRow>
                                        <TableCell style={{ fontSize: '14px' }}>
                                            Civil IDC : {caseDetails ? caseDetails.civilIDC : ''}
                                        </TableCell>
                                        <TableCell style={{ fontSize: '14px' }}>
                                            Civil CEO : {caseDetails ? caseDetails.civilCEO : ""}
                                        </TableCell>
                                    </TableRow>
                                    <TableRow>
                                        <TableCell style={{ fontSize: '14px' }}>
                                            Civil SEO : {caseDetails ? caseDetails.civilSEO : ''}
                                        </TableCell>
                                        <TableCell style={{ fontSize: '14px' }}>
                                            Civil Division : {caseDetails ? caseDetails.civilDivision : ""}
                                        </TableCell>
                                    </TableRow>
                                    <TableRow>
                                        <TableCell colSpan="4">
                                            <Table aria-label="simple table" border>
                                                <TableRow>
                                                    <TableCell style={{ fontWeight: 'bold' }}>Case Stage</TableCell>
                                                    <TableCell style={{ fontWeight: 'bold' }}>Hearing Date</TableCell>
                                                    <TableCell style={{ fontWeight: 'bold' }}>Hearing Time</TableCell>
                                                    <TableCell style={{ fontWeight: 'bold' }}>Status Date</TableCell>
                                                    <TableCell style={{ fontWeight: 'bold' }}>Case Status</TableCell>
                                                    <TableCell style={{ fontWeight: 'bold' }}>Remarks</TableCell>
                                                </TableRow>
                                                <TableBody>
                                                    {data.map((row) => (
                                                        <TableRow
                                                            key={row.detailId}
                                                            sx={{ '&:last-child td, &:last-child th': { border: 0 } }}
                                                        >
                                                            <TableCell>{row.caseStage}</TableCell>
                                                            <TableCell>{moment(row.hearingDate).format('DD/MM/YYYY')}</TableCell>
                                                            <TableCell>{row.hearingTime}</TableCell>
                                                            <TableCell>{moment(row.statusDate).format('DD/MM/YYYY')}</TableCell>
                                                            <TableCell>{row.caseStatus}</TableCell>
                                                            <TableCell>{row.remarks}</TableCell>
                                                        </TableRow>
                                                    ))}
                                                </TableBody>
                                            </Table>
                                            <div style={{ fontSize: '12px', color: 'red' }}>{errors[".caseStageId"]}</div>
                                        </TableCell>
                                    </TableRow>
                                </Table>
                            </Card>
                            <br />
                        </Card>
                    </Grid>
                </Grid>
            </MDBox>
            <div style={{ position: 'absolute', left: 0, right: 0, bottom: 0 }}>
                <Footer />
            </div>
        </DashboardLayout>
    );
}
export default CaseStatusReport;